$(document).ready(function () {
	const BtbClass = '.phone-btn',
		callUsContainer = '.call-us__container',
		overlay = '#call-us__overlay',
		delay = 500;

	$(BtbClass).click(function () {
		if (matchMedia('(max-width: 768px)').matches) {
			if (!$(callUsContainer).hasClass('active')) {
				$(overlay).fadeIn(delay);
			}else{
				$(overlay).fadeOut(delay);
			}
		}
			$(callUsContainer).toggleClass('active');
			$(callUsContainer).addClass('clicked');

	})

	if (matchMedia(' (min-width: 992px) and (max-width: 1400px)').matches) {
		let init = false,
			lastStat =  false;
			clicked =  false;

		$(callUsContainer).addClass('active');


		$(window).scroll(function (e) {
			lastStat = $(callUsContainer).hasClass('active');
			clicked = $(callUsContainer).hasClass('clicked');
			if ($(window).scrollTop() < 100) {
				if (!lastStat  || !init) {
					$(callUsContainer).addClass('active');
					init = true;
				}

			}else{
				if (lastStat && !clicked) {
					$(callUsContainer).removeClass('active');
				}
			}
		});
	}

});
